import { useEffect, useState } from "react";
import { User, Save, Loader2 } from "lucide-react";
import api from "@/lib/api";
import CommChannelsPicker from "@/components/CommChannelsPicker";
import { toast } from "sonner";

export function ProfileEditor() {
  const [form, setForm] = useState({ first_name: "", last_name: "", phone: "" });
  const [channels, setChannels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/profile").then((r) => {
      setForm({ first_name: r.data.first_name || "", last_name: r.data.last_name || "", phone: r.data.phone || "" });
      setChannels(r.data.comm_channels || []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/profile", { ...form, comm_channels: channels.filter((c) => c.value.trim()) });
      toast.success("Profil actualizat.");
    } catch { toast.error("Eroare la salvare."); }
    finally { setSaving(false); }
  };

  if (loading) return null;
  return (
    <div className="border border-slate-200 p-6 mt-8" data-testid="profile-editor">
      <h2 className="font-black text-lg tracking-tight flex items-center gap-2 mb-4"><User className="w-5 h-5 text-orange-600" /> Date personale</h2>
      <div className="grid sm:grid-cols-2 gap-4">
        <div>
          <label className="text-[11px] uppercase tracking-wide font-bold text-slate-500">Nume de familie</label>
          <input value={form.last_name} onChange={set("last_name")} className="mt-1.5 w-full border border-slate-300 px-3 py-2 text-sm focus:border-orange-500 outline-none" data-testid="profile-last-name" />
        </div>
        <div>
          <label className="text-[11px] uppercase tracking-wide font-bold text-slate-500">Prenume</label>
          <input value={form.first_name} onChange={set("first_name")} className="mt-1.5 w-full border border-slate-300 px-3 py-2 text-sm focus:border-orange-500 outline-none" data-testid="profile-first-name" />
        </div>
      </div>
      <div className="mt-4">
        <label className="text-[11px] uppercase tracking-wide font-bold text-slate-500">Telefon</label>
        <input value={form.phone} onChange={set("phone")} className="mt-1.5 w-full border border-slate-300 px-3 py-2 text-sm focus:border-orange-500 outline-none" data-testid="profile-phone" />
      </div>
      <div className="mt-4">
        <label className="text-[11px] uppercase tracking-wide font-bold text-slate-500">Canale de comunicare</label>
        <div className="mt-2"><CommChannelsPicker value={channels} onChange={setChannels} /></div>
      </div>
      <button onClick={save} disabled={saving} className="mt-5 inline-flex items-center gap-2 bg-orange-600 hover:bg-orange-700 text-white px-5 py-2 text-sm font-bold uppercase tracking-wide transition-colors disabled:opacity-50" data-testid="profile-save">
        {saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <Save className="w-4 h-4" />} Salvează
      </button>
    </div>
  );
}
